import React, { FC, useContext, useRef } from 'react'
import styled from 'styled-components'

type ContextState = { portalRef: null | React.RefObject<HTMLDivElement> }
const SelectPortalContext = React.createContext<ContextState>({ portalRef: null })

const StyledPortal = styled.div`
  position: fixed; // To prevent layout distruption: https://github.com/JedWatson/react-select/issues/810#issuecomment-215561687
  z-index: 9999;
`

const SelectPortalProvider: FC<{}> = ({ children }) => {
  const portalRef = useRef<HTMLDivElement>(null)

  return (
    <SelectPortalContext.Provider value={{ portalRef }}>
      <StyledPortal ref={portalRef} id="select-portal-container" />
      {children}
    </SelectPortalContext.Provider>
  )
}

export default SelectPortalProvider

export const useSelectPortalRef = () => {
  const context = useContext(SelectPortalContext)
  if (!context) throw new Error('Trying to access portal ref outside of provider')
  if (context.portalRef === null) return null
  return context.portalRef.current
}
